import { useStore } from "../../store";
import { observer } from "mobx-react-lite";
import TemperatureChart from "../../components/TemperatureChart";
import { cToF } from "../../utils";
import { BiXCircle } from "react-icons/bi";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import _ from 'lodash';
import moment from "moment";
import { toJS } from "mobx";


function RecordChart() {
  const { dataStore } = useStore();
  const resData = dataStore.resData;
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get('status')
  const [data, setData] = useState<{
    temperature: number;
    humidity: number;
    time: string;
    step?: number
  }[]>([])



  useEffect(() => {

    switch (status) {
      case 'active': {
        dataStore.sendData({
          action: 'getActiveRecordChart',
          data: {

          },
        });

      }
        break
      case 'log': {
        const id = searchParams.get('id')
        const type = searchParams.get('type')

        if (id && type) {
          dataStore.sendData({
            action: "loadLogContent",
            data: {
              id,
              type,
            },
          });
        }

      }
        break
    }
  }, [])


  useEffect(() => {

    switch (status) {

      case 'active': {
        setData(resData.activeRecordChartAck?.data || [])
      }
        break

      case 'finished': {
        setData(resData.runProgramRecordChartAck?.data || [])
      }
        break
      case 'log': {

        const records: {
          data: {
            temperature: number;
            humidity: number;
            time: string;
          }[];
        } = { data: [] };

        for (const data of resData.loadLogContentAck?.logContent?.data || []) {
          for (const itemData of data.data) {
            records.data.push(itemData);
          }
        }

        setData(records.data)
      }
        break
    }
  }, [resData.runProgramRecordChartAck?.data, resData.loadLogContentAck?.logContent?.data, resData.activeRecordChartAck?.data])


  const records = useMemo(() => {

    const newRecords = { data: data || [] }
    if (resData.loadSettingAck?.temperatureUnit === 'F') {
      newRecords.data = newRecords?.data?.map(item => ({ ...item, temperature: Number(cToF(item.temperature)) }))
    }

    const getTargetTemperature = (steps: { temperature: number }[] | undefined, step?: number) => {
      if (typeof step !== 'number') return undefined

      const stepData = steps?.[step]
      if (!stepData) return undefined

      return resData.loadSettingAck?.temperatureUnit === 'F'
        ? Number(cToF(stepData.temperature))
        : stepData.temperature
    }


    return {
      data: newRecords.data,
      temperatureRecored: newRecords.data.map(item => {

        let targetData: number | undefined

        switch (status) {
          case 'active': {
            targetData = getTargetTemperature(resData.activeLogAck?.activeProgram?.steps, item.step)
          }
            break
          case 'finished': {
            targetData = getTargetTemperature(resData.activeLogAck?.activeProgram?.steps, item.step)
          }
            break
          case 'log': {
            targetData = getTargetTemperature(resData.loadLogContentAck?.logContent?.program?.steps, item.step)
          }
        }



        return { data: item.temperature, time: item.time, targetData }
      }),
      humidityRecored: newRecords.data.map(item => ({ data: item.humidity, time: item.time })),
    }

  }, [
    status,
    data,
    resData.loadSettingAck?.temperatureUnit,
    resData.activeLogAck?.activeProgram?.steps,
    resData.loadLogContentAck?.logContent?.program?.steps,
  ])



  const [slidePercent, setSlidePercent] = useState(1);
  const [durationHours, setDurationHours] = useState<number | undefined>(24 * 2);
  const [startAndEndStr, setStartAndEndStr] = useState({ startStr: '-', endStr: '-' })





  const chartRecord = useMemo(
    () => {
      return {
        unit: resData.loadSettingAck?.temperatureUnit as any,
        dateFormat: resData.loadSettingAck?.dateFormat,
        temperature: records.temperatureRecored,
        humidity: records.humidityRecored,
        styleTemperature: {
          width: "95%",
          height: resData.loadSettingAck?.humidityEnabled ? 210 : 210 * 2 + 20,
          marginTop: 30,
        },
        styleHumidity: {
          width: "95%",
          height: 210,
          marginTop: 30,
        },
        XAxisTickFormatterTimeFormat: 'MM-DD HH:mm',
        durationHours,
      }
    },
    [durationHours, records.data, resData.loadSettingAck?.temperatureUnit, resData.loadSettingAck?.dateFormat, resData.loadSettingAck?.humidityEnabled] // 依赖 MobX 原始数组引用，只有它变才重新生成
  );


  // 用 useRef 持久存储 throttle 后的函数
  const throttledSetSlide = useRef(_.throttle(setSlidePercent, 80)).current;


  // 响应滑动条变化
  const handleSliderChange = (event: any) => {
    const value = Number(event.target.value)
    throttledSetSlide(value); // 通过节流函数更新 slidePercent
  }


  const onClose = () => {
    navigate(-1);
  }


  const closeslider = useMemo(() => {
    if (!records.data || records.data.length === 0 || !durationHours) return true; // 空数组默认true

    const start = moment(records.data[0].time); // 最早时间
    const end = moment(records.data[records.data.length - 1].time); // 最晚时间

    const diffHours = end.diff(start, 'hours', true); // 四舍五入取小时差值（带小数）

    return diffHours <= durationHours;

  }, [records.data, durationHours])




  const getChartView = () => {
    return (
      <div
        className="flex"
        style={{
          flexDirection: 'column',
          borderRadius: 10,
          margin: '10px 20px 20px 20px',
          justifyContent: 'center',
        }}
      >

        <TemperatureChart
          {...chartRecord}
          style={chartRecord.styleTemperature}
          records={chartRecord.temperature}
          slidePercent={slidePercent}
          onStartAdnEndTime={(data) => {
            setStartAndEndStr(data)
          }}
        />


        {resData.loadSettingAck?.humidityEnabled && (
          <TemperatureChart
            {...chartRecord}
            unit={'RH'}
            style={chartRecord.styleHumidity}
            records={chartRecord.humidity}
            slidePercent={slidePercent}
          />
        )}

      </div>
    )
  }

  const getView = () => {
    return (
      <div
        className="flex"
        style={{
          flex: 1,
          borderRadius: 20,
          borderWidth: 2,
          borderColor: 'white',
          backgroundColor: '#E7A65E',
          flexDirection: 'column',
          position: 'relative',
          boxShadow: "8px 8px 8px  rgba(0, 0, 0, 0.2)",
        }}
      >
        {getHeadView()}

        {getChartView()}

        {!closeslider && getSlidePercentView()}

        <BiXCircle
          onClick={onClose}
          style={{
            position: 'absolute',
            color: "#B1483D",
            fontSize: 70,
            margin: 10,
          }}
        />

      </div>
    )
  }

  const getSlidePercentView = () => {

    return (
      <>
        {durationHours && (
          <div
            className="flex"
            style={{
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <input
              style={{
                width: '80%',
              }}
              className="light-setting-range"
              type="range"
              value={slidePercent}
              min={0}
              max={1}
              step={0.01}
              onChange={handleSliderChange}
            />
          </div>
        )}
      </>

    )
  }

  const getHeadView = () => {
    return (
      <div
        className="flex"
        style={{
          alignItems: 'center',
          marginTop: 30,
          marginBottom: 20,
          flexDirection: 'column'
        }}
      >
        <div>
          <TimeRangeSelector
            defaultValue={'all'}
            onChangeValue={(data) => {
              setDurationHours(data.time)
            }}
          />
          <div
            className="flex"
            style={{
              height: 20,
              width: '100%',
              justifyContent: 'space-between',
              color: 'white',
              marginTop: 10,
              opacity: 0.7,
            }}
          >
            <div>{startAndEndStr.startStr}</div>
            <div>{startAndEndStr.endStr}</div>
          </div>
        </div>

      </div>
    )
  }


  return (
    <div className="flex">
      <div className="w-[1280px] h-[730px] flex">
        <div
          className="flex"
          style={{
            flex: 1,
            margin: 16,
            flexDirection: 'column',
          }}

        >
          <div
            className="flex"
            style={{
              flex: 1,
            }}
          >
            {getView()}

          </div>
        </div>
      </div>

    </div>
  );
}



type TimeRangeSelectorProps = {
  defaultValue: 'hour' | 'day' | 'week' | 'month' | 'year' | 'all'
  onChangeValue(data: {
    value: TimeRangeSelectorProps['defaultValue']
    //小时
    time?: number
  }): void
  style?: React.CSSProperties;
}

const TimeRangeSelector = (props: TimeRangeSelectorProps) => {

  const [value, setValue] = useState(props.defaultValue)



  const list: {
    value: TimeRangeSelectorProps['defaultValue']
    //小时
    time?: number
  }[] = [
      {
        value: 'hour',
        time: 1,
      },
      {
        value: 'day',
        time: 24,
      },
      {
        value: 'week',
        time: 24 * 7,
      },
      {
        value: 'month',
        time: 24 * 30,
      },
      {
        value: 'year',
        time: 24 * 365,
      },
      {
        value: 'all',
      },
    ]

  useEffect(() => {
    const data = list.find(item => item.value === props.defaultValue)
    data && props.onChangeValue(data)
  }, [props.defaultValue])


  return (
    <div
      className="flex"
      style={{
        ...props.style || {},
      }}
    >
      {list.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            setValue(item.value)
            props.onChangeValue(item)
          }}
          style={{
            backgroundColor: item.value === value ? '#406F70' : 'white',
            width: 100,
            borderWidth: 0.1,
            borderColor: 'rgba(0, 0, 0,0.6)',
            textAlign: 'center',
            borderLeftWidth: index === 0 ? 0.1 : 0,
            borderTopLeftRadius: index === 0 ? 10 : 0,
            borderBottomLeftRadius: index === 0 ? 10 : 0,
            borderTopRightRadius: index === list.length - 1 ? 10 : 0,
            borderBottomRightRadius: index === list.length - 1 ? 10 : 0,
          }}
        >
          <span
            style={{
              fontSize: 20,
              fontWeight: 400,
              color: item.value === value ? 'white' : 'rgba(0,0,0,0.6)',
            }}
          >{item.value}</span>
        </div>
      ))}

    </div>
  )
}


export default observer(RecordChart);
